import { getSearchParam } from "@utils/filters";
import axios from "../utils/axios";
import { format } from "date-fns";
import { PATIENT_KEY } from "@utils/constants";

export const getPatients = async (
  page: number = 0,
  size: number = 10,
  filter?: Record<string, string>,
  orderBy: string = "codeOP desc"
) => {
  try {
    const queryParamsFilters: Record<string, string> = {
      page: page.toString(),
      size: size.toString(),
      orderBy: orderBy.toString(),
      ...filter
    };
    const queryParams: string = getSearchParam(queryParamsFilters, PATIENT_KEY);
    const { data } = await axios.get(`patients/list?${queryParams}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getPatientsXLS = async (filter: any) => {
  try {
    const queryParams: string = getSearchParam(filter, PATIENT_KEY);
    const { data } = await axios.get(
      `patients/xls?&${queryParams}`,
      {
        responseType: "blob",
      }
    );
    console.log({ data });
    const url = window.URL.createObjectURL(new Blob([data]));
    console.log({ url });
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `patients-${format(Date.now(), "yyyy-MM-dd-hhmmss")}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    throw error;
  }
};
export const getPatientsCSV = async (filter: any) => {
  try {
    const queryParams: string = getSearchParam(filter, PATIENT_KEY);
    const { data } = await axios.get(
      `patients/csv?&${queryParams}`,
      {
        responseType: "blob",
      }
    );
    console.log({ data });
    const url = window.URL.createObjectURL(new Blob([data]));
    console.log({ url });
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `patients-${format(Date.now(), "yyyy-MM-dd-hhmmss")}.csv`
    );
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    throw error;
  }
};
export const getPatientsJSON = async (filter: any) => {
  try {
    const queryParams: string = getSearchParam(filter, PATIENT_KEY);
    const { data } = await axios.get(
      `patients/json?&${queryParams}`,
      {
        responseType: "blob",
      }
    );
    console.log({ data });
    const url = window.URL.createObjectURL(new Blob([data]));
    console.log({ url });
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `patients-${format(Date.now(), "yyyy-MM-dd-hhmmss")}.json`
    );
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    throw error;
  }
};

export const getPatient = async (patientId: string | number) => {
  try {
    const { data } = await axios.get(`patients/${patientId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const editPatient = async (patientId: string, body: any) => {
  try {
    const res = await axios.patch(`patients/${patientId}`, body);
    return res;
  } catch (error) {
    throw error;
  }
};

export const newPatient = async (body: any) => {
  try {
    const res = await axios.post(`patients`, body);
    return res;
  } catch (error) {
    throw error;
  }
};

// Samples
export const getPatientSample = async (patientId: string | number) => {
  try {
    const { data } = await axios.get(`patients/samples/${patientId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const newPatientSample = async (body: any) => {
  try {
    const res = await axios.post(`patients/samples`, body);
    return res;
  } catch (error) {
    throw error;
  }
};

export const editPatientSample = async (
  sampleId: string | number,
  sampleData: any
) => {
  try {
    const { data } = await axios.patch(
      `patients/samples/${sampleId}`,
      sampleData
    );
    return data;
  } catch (error) {
    throw error;
  }
};

// Diagnostics

export const getPatientDiagnostic = async (patientId: string | number) => {
  try {
    const { data } = await axios.get(`patients/diagnostics/${patientId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const newPatientDiagnostic = async (body: any) => {
  try {
    const res = await axios.post(`patients/diagnostics`, body);
    return res;
  } catch (error) {
    throw error;
  }
};

export const editPatientDiagnostic = async (
  diagnosticId: string | number,
  diagnosticData: any
) => {
  try {
    const { data } = await axios.patch(
      `patients/diagnostics/${diagnosticId}`,
      diagnosticData
    );
    return data;
  } catch (error) {
    throw error;
  }
};

// Treatments

export const newPatientTreatments = async (body: any) => {
  try {
    const res = await axios.post(`patients/treatments`, body);
    return res;
  } catch (error) {
    throw error;
  }
};

export const editPatientTreatments = async (
  patientId: number,
  treatments: any
) => {
  try {
    const res = await axios.put(`patients/treatments/${patientId}`, {
      treatments,
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const deletePatientTreatment = async (treatmentId: number | string) => {
  try {
    const res = await axios.delete(`patients/treatments/${treatmentId}`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const deletePatientTreatmentDrug = async (drugId: number | string) => {
  try {
    const res = await axios.delete(`patients/treatments/drugs/${drugId}`);
    return res;
  } catch (error) {
    throw error;
  }
};

// Lab Reports

export const newPatientLabReports = async (body: any) => {
  try {
    const res = await axios.post(`patients/labreports`, body);
    return res;
  } catch (error) {
    throw error;
  }
};

export const editPatientLabReports = async (
  patientId: number,
  labReports: Array<any>
) => {
  try {
    const res = await axios.put(`patients/labreports/${patientId}`, {
      labReports,
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const deletePatientReport = async (reportId: number | string) => {
  try {
    const res = await axios.delete(`patients/labreports/${reportId}`);
    return res;
  } catch (error) {
    throw error;
  }
};
